import { brandSecondary, titles } from '../../../web/styles/colors';
import { CssSelectors } from '../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		marginBottom: 20,
		marginLeft: 20,
		width: 600,
	},
	expirationDetailContainer: {
		marginBottom: 20,
	},
	infoContainer: {
		marginLeft: 4,
	},
	infoMessage: {
		borderRadius: 3,
		boxShadow: '0 0 3px 1px rgba(0,0,0,0.1)',
		color: titles,
		fontSize: 12,
		marginLeft: 4,
		maxWidth: 300,
		padding: 10,
		transform: 'translate3d(0,2px,0)',
	},
	rowContainer: {
		display: 'flex',
		marginTop: 24,
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	title: {
		color: brandSecondary,
		display: 'flex',
		fontSize: 18,
		marginBottom: 36,
	},
});
